import React from "react";
import "./LoadingPage.css";

const LoadingPage = () => {
  return (
    // <div className="loading">
    //   <img src="/pic/loading2.png" className="loading1" alt="loading pic" />
    //   <img src="/pic/loading1.png" className="loading2 loading3" alt="loading pic" />
    // </div>
    <div className="loading">
      <p>آرد زر</p>
      <img src="/pic/SVG Loading.svg" alt="wheat loader" />
    </div>
  );
};

export default LoadingPage;
